import { DateTime } from 'luxon';

export const formatDate = (dateTime: string | Date) => {
    if (!dateTime) return;

    if (typeof dateTime !== 'string') {
        if (isNaN(dateTime.getTime())) return;
        dateTime = dateTime.toISOString();
    }

    const parsed = DateTime.fromISO(dateTime, { zone: 'utc' });
    if (!parsed.isValid) return;

    return parsed.setZone('Europe/Kyiv').toFormat('yyyy-MM-dd HH:mm:ss');
};
